import React from 'react';
import '../styles/InfoCards.css';
import bulding from "../assets/DSC_1313.jpg";
import children from "../assets/student (1).webp";
import student from "../sciencelabs/chemistry (3).webp";
const InfoCards = () => {
  return (
    <div className="sgb-info-cards-wrapper">
      <div className="sgb-info-cards-container">
        
        {/* Admission Card */}
        <div className="sgb-info-card">
          <div className="sgb-card-image-wrapper">
            <div className="sgb-card-image-inner">
              <img 
                src={bulding} 
                alt="Admission" 
                className="sgb-card-image"
              />
            </div>
          </div>
          <h3 className="sgb-card-title">ADMISSION</h3>
          <p className="sgb-card-description">
            Admissions are open for the session 2023-2024. Kindly follow the site for further information and securing an admission for your ward and take a step forward.
          </p>
        </div>

        {/* Academics Card */}
        <div className="sgb-info-card">
          <div className="sgb-card-image-wrapper">
            <div className="sgb-card-image-inner">
              <img 
                src={children}
                alt="Academics" 
                className="sgb-card-image"
              />
            </div>
          </div>
          <h3 className="sgb-card-title">ACADEMICS</h3>
          <p className="sgb-card-description">
            We believe in teaching the students about the indian culture and restoring traditions while educating the youth. Saraswati is the goddess of knowledge, a perfect example of our belief.
          </p>
        </div>

        {/* Facilities Card */}
        <div className="sgb-info-card">
          <div className="sgb-card-image-wrapper">
            <div className="sgb-card-image-inner">
              <img 
                src={student}
                alt="Facilities" 
                className="sgb-card-image"
              />
            </div>
          </div>
          <h3 className="sgb-card-title">FACILITIES</h3>
          <p className="sgb-card-description">
            From a beautiful campus and well equipped classrooms to an aesthetic environment and a meditation hall, SPS has everything to give you to achieve your goals and excel.
          </p>
        </div>

      </div>
    </div>
  );
};

export default InfoCards;